import React from 'react';
import Page from '../../containers/page';
import FormBuilder from '../../form-builder';
import RouteComponent from '../../helpers/route';
import ListBuilder from '../../list-builder';
import Isvg from 'react-inlinesvg';
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Table,
} from 'reactstrap';
import editIcon from '../../assets/edit.svg';
import garbageIcon from '../../assets/garbage.svg';
import exportIcon from '../../assets/export.svg';
import DeleteModal from '../../components/deleteModal';
import FileField from '../../form-builder/fields/file';
import { required, number } from '../../form-builder/validation';
import { API_ENDPOINT } from '../../constants';

class HornbachStock extends RouteComponent {
    constructor(props) {
        super(props);
        this.state = {
            articlesList: true,
            articleForm: false,
            total: 0,
            items: [],
            deleteModal: null,
            importResult: null,
            importModal: false,
            importKey: 0,
        }
    }

    componentDidMount() {
        this._onLoad();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props[0].location.search != prevProps[0].location.search) {
            this._onLoad();
        }
    }

    export = () => {
        fetch(API_ENDPOINT + '/data/hornbach-stock/export', {
            method: 'GET',
            headers: {
                'content-type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            },
        }).then(res => res.blob()).then(data => { if (data) window.open(URL.createObjectURL(data)) })
    }

    render() {
        let params = this._getParams();

        return (
            <div>
                <div className="section-title title-options">
                    <h1>{'Hornbach Stock'.translate(this.props.lang)}</h1>

                    <div className='buttons'>

                        <FileField
                            key={this.state.importKey}
                            label={'Import CSV'.translate(this.props.lang)}
                            endpoint={'/data/hornbach-stock/import'}
                            onChange={(data) => this.setState((prev) => ({ importResult: data, importModal: true, importKey: prev.importKey + 1 }), () => this._onLoad())}
                        ></FileField>
                    </div>
                </div>

                {this.state.articleForm ?
                    <div className="table-tabs">
                        <button onClick={() => this.setState({ articleForm: false })}>
                            {'List'.translate(this.props.lang)}
                        </button>
                        <button className="active" onClick={() => this.setState({ articleForm: {} })}>
                            {'Add product'.translate(this.props.lang)}
                        </button>
                    </div>
                    : null}

                {
                    this.state.articleForm ?

                        <div>
                            <div className="side-margin">
                                <FormBuilder
                                    registerSubmitAction={(submit) => this.submit = submit}
                                    classNameForm={"add-form-container"}
                                    lang={this.props.lang}
                                    onSubmit={(data) => {
                                        if (this.state.articleForm && this.state.articleForm._id) {
                                            this._api('api4', { data: data }, (res) => {
                                                if (res && res.status >= 400) {
                                                    this.setState({ formError: res.result && res.result.error });
                                                } else {
                                                    this.setState({ articleForm: undefined, formError: null }, () => { this._onLoad(); });
                                                }
                                            });
                                        } else {
                                            this._api('api2', { data: data }, (res) => {
                                                if (res && res.status >= 400) {
                                                    this.setState({ formError: res.result && res.result.error });
                                                } else {
                                                    this.setState({ articleForm: {}, formError: null }, () => { this._onLoad(); });
                                                }
                                            });
                                        }
                                    }}
                                    initialValues={this.state.articleForm && this.state.articleForm._id ? this.state.articleForm : {}}
                                    fields={[
                                        {
                                            type: 'row',
                                            children: [
                                                {
                                                    type: 'col',
                                                    width: { lg: 12, sm: 12, xs: 12 },
                                                    children: [
                                                        {
                                                            type: 'block',
                                                            header: 'Product details'.translate(this.props.lang),
                                                            style: { paddingBottom: 33 },
                                                            children: [
                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 6, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'text',
                                                                            name: 'id',
                                                                            label: 'ID'.translate(this.props.lang),
                                                                            validate: [
                                                                                required('ID is required!'.translate(this.props.lang)),
                                                                                number('ID must be a number!'.translate(this.props.lang)),
                                                                            ]
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'name',
                                                                            label: 'Name'.translate(this.props.lang),
                                                                            validate: [
                                                                                required('Name is required!'.translate(this.props.lang)),
                                                                            ]
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'gtin',
                                                                            label: 'GTIN'.translate(this.props.lang),
                                                                            validate: [
                                                                                required('GTIN is required!'.translate(this.props.lang)),
                                                                                (value) => value && !/^\d+$/.test(String(value).trim()) ? 'GTIN must contain digits only!'.translate(this.props.lang) : undefined,
                                                                            ]
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'sku',
                                                                            label: 'SKU'.translate(this.props.lang),
                                                                            validate: [
                                                                                required('SKU is required!'.translate(this.props.lang)),
                                                                                (value) => value && !/^[A-Za-z0-9_-]+$/.test(String(value).trim()) ? 'SKU: only letters, digits, - and _ allowed!'.translate(this.props.lang) : undefined,
                                                                            ]
                                                                        },
                                                                    ]
                                                                },
                                                            ]
                                                        },
                                                    ]
                                                },
                                            ],
                                        },
                                        {
                                            type: 'row',
                                            children: [
                                                {
                                                    type: 'button',
                                                    width: { lg: 4, sm: 6, xs: 6 },
                                                    action: 'submit',
                                                    children: 'Save',
                                                    className: 'form-button',
                                                },
                                            ]
                                        }
                                    ]}
                                ></FormBuilder>
                                {this.state.formError ?
                                    <p className="error" style={{ color: 'red' }}>{this.state.formError}</p>
                                    : null}
                            </div>
                        </div>

                        :

                        <div>
                            <DeleteModal
                                isOpen={this.state.deleteModal}
                                lang={this.props.lang}
                                toggle={() => this.setState({ deleteModal: null })}
                                handler={() => {
                                    this._api('api3', { data: this.state.deleteModal._id }, () => {
                                        this.setState({ deleteModal: null }, () => this._onLoad());
                                    });
                                }} >
                                {'Delete product'.translate(this.props.lang)} <strong>{this.state.deleteModal ? this.state.deleteModal.name : ''}</strong>?
                            </DeleteModal>
                            <ListBuilder
                                tabs={true}
                                sort={true}
                                tab1Name={'List'.translate(this.props.lang)}
                                tab2Name={'Add product'.translate(this.props.lang)}
                                onClickTab1={() => {
                                    this.setState({
                                        articlesList: true,
                                        articleForm: false,
                                    })
                                    this.updateMultipleParams([{ name: 'entries', value: "10" }, { name: 'page', value: 0 }, { name: 'filter', value: '' }], true);
                                }}
                                onClickTab2={() => {
                                    this.setState({
                                        articleForm: true,
                                        articlesList: false,
                                        formError: null,
                                    })
                                }}
                                lang={this.props.lang}
                                loading={this.state.loading}
                                total={this.state.total}
                                showNumeration={false}
                                fields={[
                                    { type: 'text', name: 'id', label: 'ID'.translate(this.props.lang), allowSort: true },
                                    { type: 'text', name: 'name', label: 'NAME'.translate(this.props.lang), allowSort: true },
                                    { type: 'text', name: 'gtin', label: 'GTIN'.translate(this.props.lang), allowSort: true },
                                    { type: 'text', name: 'sku', label: 'SKU'.translate(this.props.lang), allowSort: true },
                                ]}
                                items={this.state.items}
                                actions={[
                                    {
                                        component: <Isvg src={editIcon} />,
                                        onClick: (item) => this.setState({ articleForm: item, formError: null })
                                    },
                                    {
                                        component: <Isvg src={garbageIcon} />,
                                        onClick: (item) => this.setState({ deleteModal: item })
                                    },
                                ]}
                                params={params}
                                sortField={params.sortField}
                                sortType={params.sortType}
                                updateSort={this.updateSort}
                                updateParams={this.updateParams}
                                updateMultipleParams={this.updateMultipleParams}
                            ></ListBuilder>
                        </div>
                }

                {/* CSV import result summary */}
                <Modal isOpen={this.state.importModal} toggle={() => this.setState({ importModal: false })} size="lg">
                    <ModalHeader toggle={() => this.setState({ importModal: false })}>
                        {'CSV import result'.translate(this.props.lang)}
                    </ModalHeader>
                    <ModalBody>
                        {this.state.importResult ?
                            <div>
                                <p>
                                    <strong>{'Inserted'.translate(this.props.lang)}:</strong> {this.state.importResult.inserted}
                                    {'  '}<strong>{'Updated'.translate(this.props.lang)}:</strong> {this.state.importResult.updated}
                                    {'  '}<strong>{'Deleted'.translate(this.props.lang)}:</strong> {this.state.importResult.deleted}
                                    {'  '}<strong>{'Skipped'.translate(this.props.lang)}:</strong> {this.state.importResult.skipped}
                                </p>
                                {this.state.importResult.errors && this.state.importResult.errors.length ?
                                    <div style={{ maxHeight: 260, overflowY: 'auto' }}>
                                        <Table size="sm" bordered>
                                            <thead>
                                                <tr>
                                                    <th>{'Row'.translate(this.props.lang)}</th>
                                                    <th>{'Reason'.translate(this.props.lang)}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.importResult.errors.map((err, idx) => (
                                                    <tr key={idx}>
                                                        <td>{err.row}</td>
                                                        <td>{err.reason}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                    : null}
                            </div>
                            : null}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.setState({ importModal: false })}>
                            {'Close'.translate(this.props.lang)}
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

export default Page(HornbachStock);
